<div class="material" dir="rtl" >

        <!-- <mat-tab-group animationDuration="0ms" class="left-nav">
                <mat-tab label="Autocomplete">  </mat-tab>
                <mat-tab label="Checkbox"> </mat-tab>
                <mat-tab label="Datepicker"> </mat-tab>
                <mat-tab label="Collapse">   </mat-tab>
                <mat-tab label="Slide toggle button">  </mat-tab>
                <mat-tab label="Table">  </mat-tab>
                <mat-tab label="Tabs">   </mat-tab>
                <mat-tab label="Lead form">  </mat-tab>
                <mat-tab label="Success/Fail page">    </mat-tab>
            </mat-tab-group> -->



            <app-multi-select class="app"></app-multi-select>

            <app-textbox class="app"></app-textbox>

            <app-autocomplete class="app"></app-autocomplete>

            <app-brand-buttons class="app"></app-brand-buttons>

            <app-links class="app"></app-links>

            <app-checkbox class="app"></app-checkbox>

            <app-datepicker class="app"></app-datepicker>

            <matmax-expansion class="app"></matmax-expansion>

            <app-slide-toggle class="app"></app-slide-toggle>

            <app-table class="app"></app-table>

            <app-tabs class="app"></app-tabs>

            <app-lead-form class="app"></app-lead-form>

            <app-general-form class="app"></app-general-form>

            <app-success-page class="app"></app-success-page>

          <dialog-elements-example class="app"></dialog-elements-example>

            <app-login class="app"></app-login>









   <!-- <app-button></app-button> -->

   <!-- <app-card></app-card> -->

   <!-- <app-chips></app-chips> -->

   <!-- <app-dialog></app-dialog> -->


    <!-- <app-form-field></app-form-field> -->

    <!-- <app-progress-bar></app-progress-bar> -->

   <!-- <app-progress-spiner></app-progress-spiner>

     <app-radio-button></app-radio-button>

    <app-select></app-select>  -->



    <!-- <app-slider></app-slider> -->









    <!-- <app-tooltip></app-tooltip> -->

</div>